import { Middleware } from '@nuxt/types'
import { InviteStatus } from '~/store/invites/invites.types'

const guestInvite: Middleware = async ({ app, store, redirect, route, error }) => {
  let { path, params } = route

  // Remove trailing slash
  if (path.charAt(path.length - 1) === '/') {
    path = path.slice(0, path.length - 1)
  }

  const { currentUser } = store.getters

  const { id: inviteId } = params

  if (!currentUser && !path.includes('landing')) {
    redirect(app.localePath({ name: 'invite-id-landing', params: { id: inviteId } }))
  }

  const unavailablePage = app.localePath('invite-unavailable')

  try {
    await store.dispatch('invites/fetchInvite', inviteId)
    const { status } = store.getters['invites/resourceById'](inviteId)

    if (status === InviteStatus.Cancelled || status === InviteStatus.Removed) {
      return redirect(unavailablePage)
    }
  } catch (e) {
    const { code: statusCode } = e

    if (statusCode === 403) {
      redirect(unavailablePage)
    } else {
      error({ statusCode })
    }
  }
}

export default guestInvite
